module.exports = __webpack_public_path__ + "img/netto.564ea300.png";